// Pathify
import {make} from 'vuex-pathify'

const state = {
  is_show_error: false,
  message: '',
  title: '',
}

const mutations = make.mutations(state)

const actions = {
  show: ({commit}, data) => {
    commit('title', data.title || '');
    commit('message', data.msg);
    commit('is_show_error', true);
  },
  hide: ({commit}) => {
    commit('message', '');
    commit('is_show_error', false);
  },
}

const getters = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
